<template>
    <inter-table
            :showFilters="true"
            :fields="fields"
            :filters="filters"
            action="users/society"
    >
        <template v-slot:cell(color)="data">
            <i v-bind:style="{color : `${data.item.color}`}"
                    class="fi big flaticon-rounded-black-square-shape ml-2"></i>
        </template>

        <template v-slot:cell(society)="data">
            <div class="text-uppercase text-primary">{{data.item.data.society}}</div>
            <div class="small">
                <span class="bold">Email</span> {{data.item.data.society_email}} |
                <span class="bold">Tel</span> {{data.item.data.society_phone}}
            </div>
        </template>

        <template v-slot:cell(referente)="data">
            <div class="text-uppercase text-primary">{{data.item.name}} {{data.item.surname}}</div>
            <div class="small">
                <span class="bold">Email</span> {{data.item.email}} |
                <span class="bold">Tel.</span> {{data.item.data.phone}}
            </div>
        </template>

        <template v-slot:cell(status)="data">
            <b-badge
                    class="text-uppercase px-2 py-1"
                    :variant="data.item.status === 'pending' ? 'warning' : 'success'">
                {{data.item.status}}
            </b-badge>
        </template>

        <template v-slot:cell(visura)="data">
            <inter-button
                    v-if="data.item.media.length"
                    class="mx-auto"
                    size="small"
                    @onClick="downloadVisura(data.item.media[0])"
                    label="scarica">
            </inter-button>
        </template>

        <template v-slot:cell(action)="data">
            <div class="d-flex justify-content-end">
                <inter-table-button
                        icon="flaticon-edit"
                        @onClick="$emit('onUpdate', data.item)"
                >
                </inter-table-button>
                <inter-table-button
                        @onClick="$emit('onImpersonate', data.item)"
                        icon="flaticon-switch"
                        :toConfirm="true"
                        :confirmText="`Vuoi impersonare ${data.item.data.society} ?`"
                >
                </inter-table-button>
                <inter-table-button
                        styleBtn="secondaryButton"
                        icon="flaticon-key"
                        :toConfirm="true"
                        :confirmText="`Vuoi resettare la password di ${data.item.data.society} ?`"
                        @onClick="$emit('onResetPasswordItem', data.item)"
                >
                </inter-table-button>
            </div>
        </template>

        <template slot="custom-filters">
            <b-col cols="12" md="4" class="mb-3">
                <inter-select
                        placeholder="Stato società"
                        v-model="filters.status"
                        :options="[
                                { name: 'IN ATTESA', value: 'pending'},
                                { name: 'APPROVATO', value: 'approved'}
                                ]"
                ></inter-select>
            </b-col>
        </template>

    </inter-table>
</template>

<script>
    import InterTable from "../../../components/table/InterTable";
    import InterTableButton from "../../../components/table/InterTableButton";
    import InterButton from "../../../components/form/inter-button/InterButton";
    import {mapActions} from 'vuex'
    import InterSelect from "../../../components/form/inter-select/InterSelect";
    import api from "@/api";

    export default {
        name: "AdminSocietyTable",
        components: {InterSelect, InterButton, InterTableButton, InterTable},
        data() {
            return {
                filters: {},
                fields: [
                    {key: 'color', label: '', class: 'p-0 text-center'},
                    {key: 'society', label: 'Society', class: 'text-left'},
                    {key: 'referente', label: 'Referente', class: 'text-left'},
                    {key: 'visura', label: 'Visura Camerale', class: 'text-center'},
                    {key: 'status', label: 'Stato', class: 'text-center'},
                    {key: 'action', label: ''},
                ]
            }
        },
        methods: {

            ...mapActions({
                commonDownloadFile: 'commonDownloadFile',
            }),

            // downloadVisura: function(media) {
            //     this.commonDownloadFile({
            //         url : media.url,
            //         filename : media.filename + '.' + media.extension
            //     }).then()
            //         .catch(() => {
            //             this.$bvToast.toast('Problema download', {
            //                 title: 'Alert',
            //                 variant: 'warning'
            //             });
            //         })
            // }
            downloadVisura: function(media) {
                api({
                    url: `/datatable/users/get-visura/${media.id}`,
                    method: 'POST',
                    responseType: 'blob', // Specifica che vuoi un file come blob
                })
                    .then((resp) => {
                        // Crea un blob dalla risposta
                        const blob = new Blob([resp.data], { type: resp.headers['content-type'] });
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = `${media.filename}.${media.extension}`; // Nome del file
                        link.click();
                    })
                    .catch((err) => {
                        this.$bvToast.toast('Problema download', {
                            title: 'Alert',
                            variant: 'warning',
                        });
                        console.error('Errore nel download:', err);
                    });
            }



        }
    }
</script>

<style scoped>

</style>
